import React from "react";
import { useTranslation } from "react-i18next";
import AnimatedCol from "../../../../../../components/AnimatedCol";
import BemessungswertDerMomentenTragfaehigkeit from "./BemessungswertDerMomentenTragfaehigkeit";
import BemessungswertDerNormalkraftTragfaehigkeit from "./BemessungswertDerNormalkraftTragfaehigkeit";

function TragfaehigkeitenMikropfahl({
  expand,
  normalkrafttragfaehigkeit,
  elastischeMomententragfaehigkeit,
}) {
  const { t } = useTranslation("translation");

  return (
    <div>
      <div className="row">
        <AnimatedCol expand={expand}>
          <h1>{t("inner.buckling.ofner.loadbearingCapacitiesMicropile.headline")}</h1>
        </AnimatedCol>
      </div>
      <div className="row">
        <AnimatedCol expand={expand}>
          <BemessungswertDerNormalkraftTragfaehigkeit
            normalkrafttragfaehigkeit={normalkrafttragfaehigkeit}
          />
        </AnimatedCol>

        <AnimatedCol expand={expand}>
          <BemessungswertDerMomentenTragfaehigkeit
            elastischeMomententragfaehigkeit={elastischeMomententragfaehigkeit}
          />
        </AnimatedCol>
      </div>
    </div>
  );
}
export default TragfaehigkeitenMikropfahl;
